<template>
  <div class="swipe-carousel-container">
    <v-carousel
      v-model="currentSlide"
      :show-arrows="showArrows"
      height="auto"
      :continuous="false"
      :hide-delimiters="!showButtons"
      class="swipe-carousel"
      @update:model-value="handleSlideChange"
    >
      <slot></slot>
    </v-carousel>

    <PaginationDots
      v-if="paginationDots"
      :total-items="itemCount"
      :current-index="currentSlide"
      :maxDots="5"
    />
  </div>
</template>

<script>
import PaginationDots from './PaginationDots.vue';

export default {
  name: 'SwipeCarousel',
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    height: {
      type: [String, Number],
      default: '211px'
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    showArrows: {
      type: Boolean,
      default: true
    },
    paginationDots: {
      type: Boolean,
      default: false
    },
    itemCount: {
      type: Number,
      default: 1
    },
  },
  components: { PaginationDots },
  data() {
    return {
      currentSlide: this.modelValue,
      totalSlides: this.itemCount,
      currentDot: 0
    }
  },
  watch: {
    modelValue(newVal) {
      this.currentSlide = newVal;
    },
    itemCount(newVal) {
      this.totalSlides = newVal;
    },
    currentSlide(newVal) {
      this.$emit('update:modelValue', newVal);
    }
  },
  mounted() {
    const slotChildren = this.$slots.default?.() || [];
    if (slotChildren.length === 1 && slotChildren[0].type === Symbol.for('v-fgt')) {
      this.totalSlides = this.itemCount;
    } else {
      this.totalSlides = slotChildren.length || this.itemCount;
    }
  },
  methods: {
    handleSlideChange(newValue) {
      // Prevent going beyond boundaries
      if (newValue < 0) {
        this.currentSlide = 0;
      } else if (newValue >= this.totalSlides) {
        this.currentSlide = this.totalSlides - 1;
      }
    }
  }
}
</script>

<style scoped>
  .swipe-carousel-container {
    width: 100%;
  }
  
  .swipe-carousel {
    width: 100%;
    position: relative;
    overflow: hidden !important;
    margin-bottom: 5px;
    margin-top: 25px;
    padding-bottom: 24px;
    max-height: v-bind(height);
  }
  .swipe-carousel :deep(.v-carousel__controls) {
    background: transparent !important;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -17px;
    display: flex !important;
    justify-content: center !important;
    /* z-index: 9999 !important; */
    gap: 10px;
    color: white;
  }

  .swipe-carousel :deep(.v-btn.v-btn--icon) {
    margin: 0 !important;
    padding: 0 !important;
    height: 4px !important;
    width: 4px !important;
    min-width: 4px !important;
  }

  .swipe-carousel :deep(.v-btn--active .v-icon) {
    color: var(--background-color-alt2) !important;
  }

  .swipe-carousel :deep(.v-icon--size-default) {
    font-size: unset !important;
  }

  .swipe-carousel :deep(.v-carousel__controls__item .v-icon) {
    opacity: 1 !important;
  }

</style> 